import heroDataIcon from '../assets/images/icons/hero-data-icon.png'
import heroCloudIcon from '../assets/images/icons/hero-cloud-icon.png'
import heroCiberIcon from '../assets/images/icons/hero-ciber-icon.png'

const SERVICE_OTHER_SOLUTION_CARDS_EN = [
  {
    key: 'app',
    label: 'Application Development & Modernization',
    to: '/en/application-development-modernization/',
    iconType: 'dots',
  },
  {
    key: 'data-ai',
    label: 'Data & AI',
    to: '/en/data-ai/',
    iconType: 'asset',
    icon: heroDataIcon,
  },
  {
    key: 'cloud',
    label: 'Cloud & Infrastructure',
    to: '/en/cloud-infrastructure/',
    iconType: 'asset',
    icon: heroCloudIcon,
  },
  {
    key: 'cyber',
    label: 'Cyber Security',
    to: '/en/cyber-security/',
    iconType: 'asset',
    icon: heroCiberIcon,
  },
]

const SERVICE_OTHER_SOLUTION_CARDS_PT = [
  {
    key: 'app',
    label: 'Desenvolvimento e Modernização de Aplicações',
    to: '/desenvolvimento-modernizacao-aplicacoes/',
    iconType: 'dots',
  },
  {
    key: 'data-ai',
    label: 'Dados e IA',
    to: '/dados-ia/',
    iconType: 'asset',
    icon: heroDataIcon,
  },
  {
    key: 'cloud',
    label: 'Cloud e Infraestrutura',
    to: '/cloud-infraestrutura/',
    iconType: 'asset',
    icon: heroCloudIcon,
  },
  {
    key: 'cyber',
    label: 'Cibersegurança',
    to: '/ciberseguranca/',
    iconType: 'asset',
    icon: heroCiberIcon,
  },
]

export const createServiceOtherSolutionsEn = activeKey => ({
  titleBefore: 'Take a look on other ',
  titleHighlight: 'Solutions.',
  activeKey,
  cards: SERVICE_OTHER_SOLUTION_CARDS_EN,
})

export const createServiceOtherSolutionsPt = activeKey => ({
  titleBefore: 'Descubra outras ',
  titleHighlight: 'Soluções.',
  activeKey,
  cards: SERVICE_OTHER_SOLUTION_CARDS_PT,
})

/** Application Development & Modernization (EN) — default export for existing pages. */
export const SERVICE_OTHER_SOLUTIONS_EN = createServiceOtherSolutionsEn('app')

/** Application Development & Modernization (PT) — default export for existing pages. */
export const SERVICE_OTHER_SOLUTIONS_PT = createServiceOtherSolutionsPt('app')
